import React from 'react';
import classNames from 'classnames';
import { useSelectIsAppModeNewportSingleWidget } from 'app/store/general/selectors';
import { useMyPortfolioCapsulesConfigSlice } from 'widgets/myPortfolioCapsules/store/config/configSlice';
import './MyPortfolioCapsulesSettings.scss';
import { useWidgetConfigUpdater } from 'widgets/WidgetSettingsEditing/useWidgetConfigUpdater';
import { MyPortfolioCapsulesWidgetConfigState } from 'widgets/myPortfolioCapsules/store/config/MyPortfolioCapsulesWidgetConfigState';
import Tab from 'utils/components/Tab/Tab';
import MyPortfolioCapsulesContainerSettings from 'widgets/myPortfolioCapsules/components/toolbar/MyPortfolioCapsulesContainerSettings';
import MyPortfolioCapsulesCapsuleSettings from 'widgets/myPortfolioCapsules/components/toolbar/MyPortfolioCapsulesCapsuleSettings';

export const MyPortfolioCapsulesSettingsText = 'Portfolio Capsules Settings';

export interface MyPortfolioCapsulesSettingsProps {
    onChange?: (
        nextDelta: Partial<MyPortfolioCapsulesWidgetConfigState>
    ) => void;
}

export default function MyPortfolioCapsulesSettings(
    props: MyPortfolioCapsulesSettingsProps
) {
    const { onChange } = props;
    const isAppModeNewportSingleWidget =
        useSelectIsAppModeNewportSingleWidget();

    const { config, dispatchConfigChanged } =
        useMyPortfolioCapsulesConfigSlice();

    const { debouncedApplyWidgetConfigChange } = useWidgetConfigUpdater(
        dispatchConfigChanged,
        onChange
    );

    const containerSettings = (
        <MyPortfolioCapsulesContainerSettings
            debouncedApplyWidgetConfigChange={debouncedApplyWidgetConfigChange}
            config={config}
        />
    );

    const capsuleSettings = (
        <MyPortfolioCapsulesCapsuleSettings
            config={config}
            debouncedApplyWidgetConfigChange={debouncedApplyWidgetConfigChange}
        />
    );

    return (
        <div
            className={classNames(
                'MyPortfolioCapsulesSettings',
                isAppModeNewportSingleWidget && 'single-widget'
            )}
        >
            <Tab
                className="tabbed-panel"
                panes={[
                    { title: 'Container', render: containerSettings },
                    { title: 'Capsule', render: capsuleSettings },
                ]}
            />
        </div>
    );
}
